import { differenceInMinutes } from "date-fns";

import { PRODUCTS_KEYS, Product } from "constants/product";
import { useAgentFlag } from "hooks/use-agent-flag";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const findFlagName = (product: Product) => {
  if (product in PRODUCTS_KEYS) {
    return PRODUCTS_KEYS[product as keyof typeof PRODUCTS_KEYS];
  }
  return undefined;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useProductFeature(product: Product) {
  const flagName = findFlagName(product);
  const featureFlagExists = !!flagName;

  const [lastVisitedDate, setVisitedDate] = useAgentFlag(flagName);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const updateProductFlag = () => {
    const shouldUpdate =
      featureFlagExists && (!lastVisitedDate || Math.abs(differenceInMinutes(new Date(), lastVisitedDate)) > 2);

    if (shouldUpdate) {
      setVisitedDate(new Date().toISOString());
    }
  };

  return updateProductFlag;
}
